// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import VueSession from 'vue-session'
import FusionCharts from 'fusioncharts'
import Charts from 'fusioncharts/fusioncharts.charts'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueBarcode from 'vue-barcode';
import * as $ from 'jquery';
import Vuesax from 'vuesax'


Charts(FusionCharts)
Vue.use(VueSession)
Vue.use(VueSweetalert2)
Vue.use(VueBarcode)
Vue.use($)
Vue.use(Vuesax)
Vue.config.productionTip = false
window.$ = window.jQuery = require('jquery');


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
